export enum ParameterReferenceType {
    VALUE = 'VALUE',
    EXPRESSION = 'EXPRESSION',
}
